import React from "react";
import { useInfo } from "context/InfoContext";
import MenuLeft from "components/menuleft";

export default function LeftContent({ userData, menuActive, setMenuActive }) {
  const { infos } = useInfo();
  const staffID = infos?.staff_id && infos?.staff_id > 0 ? infos.staff_id : 0;
  return (
    <MenuLeft
      id="left-content"
      userData={userData}
      staffID={staffID}
      tabActive={infos.tabActive}
    />
  );
}
